document.addEventListener('DOMContentLoaded', (event) => {
	if (document.body.classList.contains('woocommerce-checkout')) {
		setContent();
	}
	// This event is jQuery, so jQuery must be used to capture it.
	jQuery('.woocommerce-checkout').on('wpmc_after_switching_tab', setContent);
});

/**
 * Set different content on the multi part checkout cart.
 */
function setContent() {
	const skipButton = document.getElementById('wpmc-skip-login');
	if (skipButton) {
		if (buttoni18n.skip) {
			skipButton.innerText = buttoni18n.skip;
		}
		if (!document.getElementById('wpmc-skip-login-instructions')) {
			const instructions = document.createElement('div');
			instructions.id = 'wpmc-skip-login-instructions';
			skipButton.parentElement.prepend(instructions);
		}
		if (buttoni18n.skipText) {
			const instructions = document.getElementById('wpmc-skip-login-instructions');
			if (skipButton.classList.contains('current')) {
				instructions.innerText = buttoni18n.skipText;
			} else {
				instructions.innerText = '';
			}
		}
	}
	const prevButton = document.getElementById('wpmc-prev');
	if (prevButton && buttoni18n.prev) {
		prevButton.innerText = buttoni18n.prev;
	}
	const nextButton = document.getElementById('wpmc-next');
	if (nextButton && buttoni18n.next) {
		nextButton.innerText = buttoni18n.next;
	}
}
